var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.as,{tag:"component",staticClass:"set_slat_ctg",on:{"click":_vm.setCategory}},[_c('figure',{staticClass:"set_slat__wrapper"},[_vm._t("image"),_c('figcaption',{staticClass:"set_slat__caption"},[_vm._t("default")],2)],2)])}
var staticRenderFns = []

export { render, staticRenderFns }